export const translations = {
  pt: {
    locale: 'pt-br',
    messages: {
      additionalFieldHelperText: 'Digite as informações adicionais',
      additionalFieldLabel: 'Informações adicionais',
      tableHeaderResId: 'ID da reserva',
      tableHeaderName: 'Nome',
      tableHeaderCheckin: 'Check In',
      tableHeaderCheckout: 'Check Out',
      findYourReservationByNameOrEmail: 'Encontre sua reserva pelo email',
      clickHere: 'Clique aqui',
      or: 'ou',
      search: 'Buscar',
      andSearchForYourData: 'e pesquise pelos seus dados',
      findPropertySubHeader: 'Para qual hostel ou hotel você está indo?',
      findPropertyByName: 'Busque pelo nome',
      homeSubHeader: 'Insira o Localizador da Reserva',
      localizadorNotFound: 'Não foi possível encontrar a reserva',
      txtName: 'Nome',
      txtEmail: 'E-mail',
      localizadorLabel: 'Localizador da Reserva',
      localizadorError: 'Insira o localizador da reserva',
      previousLabel: 'Retornar',
      nextLabel: 'Prosseguir',
      saveLabel: 'Salvar',
      phoneLabel: 'Telefone: ',
      guestsLabel: 'Hospedes: ',
      guestLabel: 'Hospede ',
      reservationTitle: 'Reserva',
      chooseRoomLabel: 'Escolha o quarto e preencha seus dados ',
      roomLabel: 'Quarto ',
      guestSubtitle: 'Os hóspedes a registar: ',
      reservationLabel: 'Reserva ',
      firstNameLabel: 'Nome',
      firstNameHelperText: 'Digite seu nome',
      lastNameLabel: 'Sobrenome',
      lastNameHelperText: 'Digite seu sobrenome',
      emailLabel: 'E-mail',
      emailHelperText: 'Digite um email válido',
      telephoneLabel: 'Telefone',
      telephoneHelperText: 'Digite o número de telefone',
      documentLabel: 'Documento de identificação',
      documentHelperText: 'Digite seu Documento de identificação',
      dateinputLabel: 'Data de Nascimento',
      dateinputHelperText: 'Digite seu Data de Nascimento',
      genderLabel: 'Sexo',
      genderHelperText: 'Selecione um sexo',
      mandatoryField: 'Necessário',
      countryLabel: 'País',
      countryHelperText: 'Selecione um país',
      uploadPhotoText: 'Carregar uma foto',
      uploadPhotoHelperText: 'Envie sua melhor foto para nossos registros',
      uploadDocumentPhotoText: 'Carregar a foto do documento',
      uploadDocumentPhotoHelperText:
        'Carregue uma imagem nítida do seu documento com foto (ex: RG, CNH, PASSAPORTE)',
      uploadDocumentRequired: 'É obrigatório o envio de uma foto de seu documento',
      uploadPhotoRequired: 'É obrigatório o envio de uma foto',
      question1Label: 'De onde você está vindo?',
      questionHelperText: 'Responda esta pergunta',
      question2Label: 'Qual seu próximo destino?',
      question3Label: 'Qual é o motivo da sua viagem?',
      question4Label:
        'Qual o principal motivo pelo qual você escolheu nosso hotel',
      question5Label:
        'Você gostaria de receber informações sobre bons hotels na sua próxima parada?',
      countryEntryDateLabel: 'Data de entrada no país',
      countryEntryDateHelperText: 'Informe a data de entrada no país',
      transportMethodLabel: 'Meio de transporte',
      transportMethodHelperText: 'Selecione o meio de transporte',
      transportMethodAirplane: 'Avião',
      transportMethodBus: 'Ônibus',
      transportMethodCar: 'Carro',
      transportMethodShip: 'Navio',
      transportMethodTrain: 'Trem',
      transportMethodOther: 'Outro',
      acceptTermsLabel: 'Ler e aceitar os termos e condições',
      acceptTermsHelperText: 'Você deve aceitar os termos',
      successTitle: 'Sucesso!',
      successSubTitle: 'Você fez checkin',
      successText: 'Suas informações foram registradas com sucesso.',
      moreAboutYouLabel: 'Conte-nos um pouco mais sobre você',
      errorTitle: 'Erro!',
      errorSubTitle: 'Ocorreu um erro',
      errorText: 'Erro inesperado ao tentar salvar, clique em prosseguir',
      dateformat: 'dd/MM/yyyy',
      emptyCheckin: 'Não tem convidados para se inscrever',
      termsAndConditionsTitle: 'Termos e Condições',
      forwardToNextGuestLabel: 'Registre outro hóspede',
      shareLinkLabel: 'Compartilhar',
      shareLinkCopyLabel: 'Copiar Link p/ Compartilhamento',
      shareLinkWhatsappLabel: 'Compartilhar p/ Whatsapp',
      shareCheckinOnlineMsg: 'Faça seu checkin online através da URL',
      shareLinkEmailLabel: 'Compartilhar p/ E-mail',
      linkSharedLabel: 'Link copiado',
      addressLabel: 'Endereço',
      addressHelperText: 'Digite seu endereço',
      numberLabel: 'Número',
      numberHelperText: 'Digite o número do seu endereço',
      complementLabel: 'Complemento',
      complementHelperText: 'Digite o complemento do seu endereço',
      neighborhoodLabel: 'Bairro',
      neighborhoodHelperText: 'Digite seu bairro',
      taxIdLabel: 'CPF',
      taxIdHelperText: 'Digite seu CPF',
      cityLabel: 'Cidade',
      cityHelperText: 'Digite sua cidade',
      stateLabel: 'Estado',
      stateHelperText: 'Digite seu status',
      postalCodeLabel: 'CEP',
      postalCodeHelperText: 'Digite seu CEP',
      checkinOnlineCompleted: 'Check in online já realizado',
      payLabel: 'Pagar',
      balanceToPayLabel: 'Saldo a pagar',
      balanceToPayMessage: 'Se você deseja efetuar o pagamento do saldo da reserva, ajuste o valor abaixo, caso necessário, e clique em PAGAR',
      checkinOtherGuestsMessage: 'Caso você deseje fazer o checkin de outros hóspedes, clique no botão abaixo ou compartilhe com eles.'
    }
  },
  en: {
    locale: 'en-US',
    messages: {
      additionalFieldHelperText: 'Enter additional information',
      additionalFieldLabel: 'Additional Information',
      tableHeaderResId: 'Reservation ID',
      tableHeaderName: 'Name',
      tableHeaderCheckin: 'Check In',
      tableHeaderCheckout: 'Check Out',
      findYourReservationByNameOrEmail: 'Find your reservation by its e-mail',
      clickHere: 'Click here',
      or: 'or',
      search: 'Search',
      txtName: 'Name',
      txtEmail: 'E-mail',
      andSearchForYourData: 'and search for your data',
      findPropertySubHeader: 'Which hostel or hotel are you going to?',
      findPropertyByName: 'Search by name',
      homeSubHeader: 'Enter Reservation Locator',
      localizadorNotFound: 'Booking Not Found',
      localizadorLabel: 'Booking Reference',
      localizadorError: 'Enter Reservation Locator',
      previousLabel: 'Previous',
      nextLabel: 'Next',
      saveLabel: 'Save',
      phoneLabel: 'Phone: ',
      guestLabel: 'Guest ',
      guestsLabel: 'Guests: ',
      reservationTitle: 'Reservation',
      chooseRoomLabel: 'Choose a room and fill in your data',
      roomLabel: 'Room ',
      guestSubtitle: 'Guests to check in: ',
      reservationLabel: 'Reservation ',
      firstNameLabel: 'First Name',
      firstNameHelperText: 'Type your name',
      lastNameLabel: 'Last Name',
      lastNameHelperText: 'Type your last name',
      emailLabel: 'E-mail',
      emailHelperText: 'Type a valid email address',
      telephoneLabel: 'Phone',
      telephoneHelperText: 'Type your phone number',
      documentLabel: 'Identification document',
      documentHelperText: 'Type your ID',
      dateinputLabel: 'Date of birth',
      dateinputHelperText: 'Type your birth date',
      genderLabel: 'Gender',
      genderHelperText: 'Select a gender',
      mandatoryField: 'Required',
      countryLabel: 'Country',
      countryHelperText: 'Select a Country',
      uploadPhotoText: 'Upload a photo',
      uploadPhotoHelperText: 'Send your best photo to our records',
      uploadDocumentPhotoText: 'Upload a document photo',
      uploadDocumentPhotoHelperText:
        'Upload a clear image of your photo document (eg: ID, PASSPORT)',
      uploadDocumentRequired: 'The upload of your photo document is required',
      uploadPhotoRequired: 'The upload of a self picture is required',
      question1Label: 'Where are you coming from?',
      questionHelperText: 'Answer this question',
      question2Label: 'What is your next destination?',
      question3Label: 'What is the purpose of your trip?',
      question4Label: 'What is the main reason you chose our hotel?',
      question5Label:
        'Would you like to receive information about good hotels at your next stop?',
      countryEntryDateLabel: 'Country entry date',
      countryEntryDateHelperText: 'Enter the date you arrived in the country',
      transportMethodLabel: 'Means of transport',
      transportMethodHelperText: 'Select the means of transport',
      transportMethodAirplane: 'Airplane',
      transportMethodBus: 'Bus',
      transportMethodCar: 'Car',
      transportMethodShip: 'Ship',
      transportMethodTrain: 'Train',
      transportMethodOther: 'Other',
      acceptTermsLabel: 'Read and accept the terms and conditions',
      acceptTermsHelperText: 'You must accept the terms and conditions',
      successTitle: 'Success!',
      successSubTitle: 'You checked in.',
      successText: 'Your information has been successfully saved',
      moreAboutYouLabel: 'Tell us a little more about yourself',
      errorTitle: 'Sorry',
      errorSubTitle: 'Error',
      errorText: 'Something went wrong trying to save, click Next',
      dateformat: 'MM/dd/yyyy',
      emptyCheckin: 'You do not have guests to register',
      termsAndConditionsTitle: 'Terms and Conditions',
      forwardToNextGuestLabel: 'Register another Guest',
      shareLinkLabel: 'Share',
      shareLinkCopyLabel: 'Copy Link for Sharing',
      shareLinkWhatsappLabel: 'Share w/ Whatsapp',
      shareCheckinOnlineMsg:
        'Check in online your reservation using the follow link',
      shareLinkEmailLabel: 'Share w/ E-mail',
      linkSharedLabel: 'Link copied',
      addressLabel: 'Address',
      addressHelperText: 'Type your address',
      numberLabel: 'Number',
      numberHelperText: 'Type your address number',
      complementLabel: 'Complement',
      complementHelperText: 'Type your address complement',
      neighborhoodLabel: 'Neighborhood',
      neighborhoodHelperText: 'Type your neighborhood',
      taxIdLabel: 'Tax ID',
      taxIdHelperText: 'Type your Tax ID',
      cityLabel: 'City',
      cityHelperText: 'Type your city',
      stateLabel: 'State',
      stateHelperText: 'Type your state',
      postalCodeLabel: 'Zip Code',
      postalCodeHelperText: 'Type your zip code',
      checkinOnlineCompleted: 'Check in online already completed',
      payLabel: 'Pay',
      balanceToPayLabel: 'Balance due',
      balanceToPayMessage: 'If you wish to pay the remaining balance of your reservation, adjust the amount below if necessary and click PAY.',
      checkinOtherGuestsMessage: 'If you wish to check in other guests, click the button to proceed or share this link with them.'
     }
  },
  es: {
    locale: 'es-ES',
    messages: {
      additionalFieldHelperText: 'Ingrese información adicional',
      additionalFieldLabel: 'Informaciones adicionales',
      tableHeaderResId: 'ID de reserva',
      tableHeaderName: 'Nombre',
      tableHeaderCheckin: 'Check In',
      tableHeaderCheckout: 'Check Out',
      findYourReservationByNameOrEmail:
        'Encuentra tu reserva por el correo electrónico',
      clickHere: 'haga clic aquí',
      or: 'ou',
      search: 'Buscar',
      txtName: 'Nombre',
      txtEmail: 'E-mail',
      andSearchForYourData: 'y busca tus datos',
      findPropertySubHeader: '?A qué hostal vas a ir?',
      findPropertyByName: 'Busque por el nombre',
      homeSubHeader: 'Ingrese el localizador de la reserva',
      localizadorNotFound: 'No se encontró la reserva',
      localizadorLabel: 'Localizador de Reserva',
      localizadorError: 'Ingrese el localizador de la reserva',
      previousLabel: 'Anterior',
      nextLabel: 'Siguiente',
      saveLabel: 'Guardar',
      phoneLabel: 'Teléfono: ',
      guestLabel: 'Huésped ',
      guestsLabel: 'Huéspedes: ',
      reservationTitle: 'Reserva',
      chooseRoomLabel: 'Escoja un cuarto y rellene sus datos',
      roomLabel: 'Cuarto ',
      guestSubtitle: 'Huéspedes a Registrar: ',
      reservationLabel: 'Reservación ',
      firstNameLabel: 'Nombre',
      firstNameHelperText: 'Ingrese su nombre',
      lastNameLabel: 'Apellido',
      lastNameHelperText: 'Ingrese su apellido',
      emailLabel: 'Correo Eléctronico',
      emailHelperText: 'Ingrese una dirección de correo electrónico válida.',
      telephoneLabel: 'Teléfono',
      telephoneHelperText: 'Ingrese su número de teléfono',
      documentLabel: 'Documento de Identificación',
      documentHelperText: 'Ingrese su número de Identificación',
      dateinputLabel: 'Fecha de Nacimiento',
      dateinputHelperText: 'Ingrese su Fecha de Nacimiento',
      genderLabel: 'Género',
      genderHelperText: 'Seleccione un género',
      mandatoryField: 'Requerido',
      countryLabel: 'País',
      countryHelperText: 'Seleccione un País',
      uploadPhotoText: 'Subir foto',
      uploadPhotoHelperText: 'Envía tu mejor foto a nuestros registros.',
      uploadDocumentPhotoText: 'Subir foto del documento',
      uploadDocumentPhotoHelperText:
        'Subir una imagen clara de su documento con foto (por ejemplo: ID, PASAPORTE)',
      uploadDocumentRequired: 'Se requiere la carga de su documento fotográfico',
      uploadPhotoRequired: 'Se requiere la carga de su foto',
      question1Label: '¿De donde vienes?',
      questionHelperText: 'Responda esta pregunta',
      question2Label: '¿Cúal es tu próximo destino?',
      question3Label: '¿Cúal es el motivo de tu viaje?',
      question4Label:
        '¿Cúal es la razón principal por la cual escojiste nuestro hotel?',
      question5Label:
        '¿Le gustaría recibir información sobre buenos hoteles en su próxima parada?',
      countryEntryDateLabel: 'Fecha de entrada al país',
      countryEntryDateHelperText: 'Indique la fecha de entrada al país',
      transportMethodLabel: 'Medio de transporte',
      transportMethodHelperText: 'Seleccione el medio de transporte',
      transportMethodAirplane: 'Avión',
      transportMethodBus: 'Autobús',
      transportMethodCar: 'Coche',
      transportMethodShip: 'Barco',
      transportMethodTrain: 'Tren',
      transportMethodOther: 'Otro',
      acceptTermsLabel: 'Leer y aceptar los términos y condiciones',
      acceptTermsHelperText: 'Debe aceptar los términos y condiciones',
      successTitle: 'Éxito!',
      successSubTitle: 'Checkin exitoso.',
      successText: 'Su información ha sido grabada con éxito',
      moreAboutYouLabel: 'Cuentanos mas sobre ti',
      errorTitle: 'Error!',
      errorSubTitle: 'Ocurrió un error',
      errorText: 'Ocurrió un error al intentar guardar, haz clic en Siguiente',
      dateformat: 'dd/MM/yyyy',
      emptyCheckin: 'No tiene huéspedes a los cuales registrar',
      termsAndConditionsTitle: 'Términos y Condiciones',
      forwardToNextGuestLabel: 'Registrar otro Huesped',
      shareLinkLabel: 'Compartir',
      shareLinkCopyLabel: 'Copiar Link p/ Compartir',
      shareLinkWhatsappLabel: 'Compartir p/ Whatsapp',
      shareCheckinOnlineMsg:
        'Haz Check in online en su reserva através del link ',
      shareLinkEmailLabel: 'Compartir p/ E-mail',
      linkSharedLabel: 'Link copiado',
      addressLabel: 'Dirección',
      addressHelperText: 'Ingrese su dirección',
      numberLabel: 'Número',
      numberHelperText: 'Digite o número do seu endereço',
      complementLabel: 'Complemento',
      complementHelperText: 'Digite o complemento do seu endereço',
      neighborhoodLabel: 'Bairro',
      neighborhoodHelperText: 'Digite seu bairro',
      taxIdLabel: 'CPF',
      taxIdHelperText: 'Digite seu CPF',
      cityLabel: 'Ciudad',
      cityHelperText: 'Ingrese su ciudad',
      stateLabel: 'Estado o Región',
      stateHelperText: 'Ingrese su Estado',
      postalCodeLabel: 'Código Postal',
      postalCodeHelperText: 'Ingrese su código postal',
      checkinOnlineCompleted: 'El check-in online ya se ha completado.',
      payLabel: 'Pagar',
      balanceToPayLabel: 'Saldo deudor',
      balanceToPayMessage: 'Si desea pagar el saldo restante de su reserva, ajuste el monto a continuación si es necesario y haga clic en PAGAR.',
      checkinOtherGuestsMessage: 'Si desea registrar a otros huéspedes, haga clic en el botón para continuar o compartir este link con ellos.'
    }
  }
}
